<template>
  <div class="main">
    <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar
        title="电子健康卡管理"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>

    <van-tabs v-model="activeName" color="#5d8bf6">
      <van-tab title="已升级" name="a">
        <div v-if="showempty" class="empty">
          <van-empty
            image="https://account.kmmds.top/datainfo_pic/error.png"
            description="暂无绑定电子健康卡"
          />
        </div>
        <div class="cardhealthlist" v-if="!showempty">
          <div
            class="wrap"
            @click="CardInformationBtn(item)"
            v-for="(item, index) in carlist"
            :key="index"
          >
            <div class="card-face-container">
              <img
                class="card-bg"
                src="../ElectronicHealthCard/PictureHealthCardImg/cardnewbg.png"
                alt=""
              />
              <div class="card-top-info">
                <div class="card-top-org">云南省卫生健康委员会</div>
                <div class="card-top-title">
                  <img
                    src="../ElectronicHealthCard/PictureHealthCardImg/icon2.png"
                    alt=""
                  />
                  <span >电子健康卡</span>
                </div>
              </div>
              <div class="card-detail-info">
                <div class="card-user-info">
                  <span class="card-user-name">{{ item.name }}</span>
                  <span class="card-user-id">{{
                    item.id_number | hideMiddle
                  }}</span>
                </div>
                <div class="card-qrcode">
                  <div>
                    <div class="qrcodeBox">
                      <div :id="`qrcode${item.qrcode}`" ref="qrcode"></div>
                    </div>
                  </div>
                  <!-- 二维码弹出层 -->
                  <img
                    class="card-qrcode-logo"
                    src="../ElectronicHealthCard/PictureHealthCardImg/logo_.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="card-footer">
                中华人民共和国国家卫生健康委员会监制
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="未升级" name="b">
        <div v-if="showempty2" class="empty">
          <van-empty
            image="https://account.kmmds.top/datainfo_pic/error.png"
            description="暂无未升级就诊卡"
          />
        </div>
        <div class="cell">
          <div
            class="item"
            size="large"
            v-for="(item, index) in HealCardFlaglist"
            :key="index"
            v-if="!item.HealCardFlag"
          >
            <div class="cell_item">
              <div class="title">{{ item.PatientName }}</div>
              <div class="value">{{ item.PatientID }}</div>
            </div>
            <div class="cell_item">
              <div class="value">tel: {{ item.Mobile }}</div>
              <!-- class="btn_mini_style" -->
              <div>
                <van-button type="info" @click="upgradecard(item)"
                  >升级健康卡</van-button
                >
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 卡片列表 -->

    <div class="foot">
      <div class="buttom" @click="add">
        <div>+ 添 加 健 康 卡</div>
      </div>
      <div class="relevance">你还可以办理{{ 5 - carlist.length }}张卡</div>
    </div>
  </div>
</template>
<script>
import ProductQrcode from "../ElectronicHealthCard/components/ProductQrcode";
import Nav from "../ElectronicHealthCard/components/nav";
import QRCode from "qrcodejs2";
// import backindex from "@/mixins/backindex";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  components: {
    Nav,
    ProductQrcode,
  },
  data() {
    return {
      showempty2: false,
      HealCardFlaglist: [],
      activeName: "a",
      carlist: [],
      redirect_url: "/personal",
      healthCode: "",
      qrCodeText: "",
      clientId: "",
      showempty: false,
      qr: null,
    };
  },
  created() {
    // this.getPayWay();
  },
  mounted() {
    if (this.$route.query.healthCode) {
      this.healthCode = this.$route.query.healthCode;
      if (this.healthCode == "0") {
        this.queryhealthcardlist();
      } else {
        this.getHealthCardByHealthCode();
      }
      return;
    }
    if (this.$route.query.updatefalg) {
      this.updatehealthcard();
      return;
    }
    this.queryhealthcardlist();
    this.queryHealCardFlag();
  },
  methods: {
     
    async updatehealthcard() {
      let {
        cid,
        cname,
        phone,
        birthday,
        genderId,
        nationId,
        wechatCode,
        patid,
      } = this.$route.query;
      try {
        this.$showLoad();
        let data = {
          name: cname,
          gender: genderId,
          nation: nationId,
          birthDay: birthday,
          idNumber: cid,
          phone1: phone,
          patid,
          wechatCode,
        };
        let url = "/healthcardcontroller/updateHealthCardIdD";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status == 200) {
              this.queryhealthcardlist();
              this.queryHealCardFlag();
            } else {
              this.$toast.fail("升级失败，请稍后重试");
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async upgradecard(item) {
      try {
        this.$showLoad();
        let data = {
          redirect_uri: `http://account.kmmds.top/HealthcardListD?updatefalg=true&cid=${item.IDCardNo}&cname=${item.PatientName}&phone=${item.Mobile}&birthday=${item.Birthday.substr(0,item.Birthday.length-8)}&genderId=${item.PatientSex}&nationId=${item.Naty}&patid=${item.PatientID}`,
        };
        let url = "/healthcardcontroller/getwechatcode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status == 200 && data.data.url) {
              window.location.href = data.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    // 获取健康码
    async gethealthCode() {
      try {
        this.$showLoad();
        let data = {
          redirect_uri: "http://account.kmmds.top/HealthcardListD",
        };
        let url = "/healthcardcontroller/healthCode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            window.location.href = data.data.url;
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    // 请求健康卡信息
    async getHealthCardByHealthCode() {
      try {
        this.$showLoad();
        let data = {
          healthCode: this.healthCode,
          pid: this.clientId,
        };
        let url = "/healthcardcontroller/getHealthCardByHealthCodeD";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
             this.queryhealthcardlist();
              this.queryHealCardFlag();

           
          }
        );
      } catch (error) {}
    },
    async queryHealCardFlag() {
      try {
        this.$showLoad();
        let data = {
          // qrCodeText:this.carlist.qrCodeText
        };
        let url = "/healthcardcontroller/queryHealCardFlag";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            // console.log(data)
            this.HealCardFlaglist = data.data;
          }
        );
      } catch (error) {}
    },
    // 获取二维码信息

    async queryhealthcardlist() {
      try {
        this.$showLoad();
        let data = {
          // qrCodeText:this.carlist.qrCodeText
        };
        let url = "/healthcardcontroller/queryhealthcardlist";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if (data.data.length == 0) {
              this.showempty = true;
            }
            // console.log(data)
            this.carlist = data.data;
            console.log(this.carlist)
            if (this.carlist.length !== 0) {
              this.crateQrcode();
            }
            this.$hideLoad();
          }
        );
      } catch (error) {}
    },
    crateQrcode() {
      this.$nextTick(() => {
        this.carlist.forEach((item, index) => {
          this.$refs.qrcode[index].innerHTML = "";
          var qrcode = new QRCode(this.$refs.qrcode[index], {
            text: item.qrcode, //二维码内容
            width: 85,
            height: 85,
            render: "table",
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
          });
        });
      }, 500);

      // this.carlist.forEach((element) => {
      //   this.qr = new QRCode(`qrcode${element.qrcode}`, {
      //     width: 85,
      //     height: 85, // 高度
      //     text: element.qrcode, // 二维码内容
      //   });
      // });
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    // 跳转到卡片信息
    CardInformationBtn(item) {
      this.$router.push({
        path: "/CardInformationD",
        query: {
          carlist: item,
          name: item.name,
          id_number: item.id_number,
          id_type: item.id_type,
          healthcardid: item.healthcardid,
          pid: item.pid,
        },
      });
    },
    // 添加健康卡按钮
    async add() {
      if (5 - this.carlist.length == 0) {
        this.$toast.fail("已绑定5张卡，不可新增");
        return;
      }
      // 请求node获取跳转地址
      try {
        this.$showLoad();
        let data = {
          redirect_uri: `http://account.kmmds.top/personalcreateD`,
        };
        let url = "/healthcardcontroller/getwechatcode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status == 200 && data.data.url) {
              window.location.href = data.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
  filters: {
    hideMiddle(val) {
      return `${val.substring(0, 4)}**********${val.substring(val.length - 4)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav {
  height: 7vh;
}
.main {
  max-height: 100vh;
}
.empty{
    height: 75vh;
}
.cardhealthlist {
  height: 75vh;
  overflow-y: auto;
}
.cell {
  display: flex;
  flex-direction: column;
  width: 93%;
  margin: 0px auto;
  height: 75vh;
  .cell_item {
    display: flex;
    flex-direction: row;
    line-height: 40px;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    .title {
      font-size: 18px;
      color: #323233;
    }
    .value {
      font-size: 16px;
      color: #555;
    }
    .label {
      font-size: 15px;
      color: #999;
    }
  }
  // margin-top: 15px;
}
.item {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  padding-bottom: 16px;
  &::after {
    border-bottom: 0;
  }
  margin-bottom: 15px;
  background-color: #f7f8fa;
  box-shadow: 0 8px 12px #ebedf0;
  border-radius: 8px;
}

.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #f4f4f4;
  width: 100%;
  height: 200px;
  margin: 10px auto;
}

.card-face-container {
  height: 9.35rem;
  width: 16.54rem;
  margin: 0px auto;
  position: relative;
  color: #000000;
}

.card-face-container .card-bg {
  height: 100%;
  width: 100%;
  position: absolute;
}

.card-face-container .card-top-info {
  position: absolute;
  top: 0.55rem;
  width: calc(100% - 0.8rem - 0.102rem);
  padding: 0 0.78rem 0 1rem;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.card-face-container .card-top-info .card-top-org {
  font-size: 12px;
  line-height: 0.75rem;
}

.card-face-container .card-top-info .card-top-title {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  line-height: 0.42rem;
  color: #2b2b2b;
}

.card-face-container .card-top-info .card-top-title img {
  height: 1.65rem;
  width: 1.65rem;
  margin-right: 0.2rem;
}

.card-face-container .card-detail-info {
  position: absolute;
  top: 3rem;
  width: calc(100% - 1.02rem - 0.45rem);
  padding: 0 0.45rem 0 1.02rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.card-face-container .card-detail-info .card-user-info {
  font-size: 1.08rem;
  color: #2b2b2b;
}

.card-face-container .card-detail-info .card-user-info .card-user-name {
  height: 0.15rem;
}

.card-face-container .card-detail-info .card-user-info .card-user-id {
  font-size: 0.9rem;
  line-height: 0.9rem;
  display: block;
  padding-top: 0.48rem;
}

.card-face-container .card-detail-info .card-qrcode {
  width: 85px;
  height: 85px;
  background: #ffffff;
  padding: 0.04rem;
  position: relative;
}
.card-face-container .card-detail-info .card-qrcode .card-qrcode-logo {
  height: 1.32rem;
  width: 1.32rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card-face-container .card-detail-info .card-qrcode img {
  width: 85px;
  height: 85px;
}

.card-face-container .card-footer {
  position: absolute;
  font-size: 13px;
  bottom: 0.48rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  letter-spacing: 0;
  line-height: 0.25rem;
}
.buttom {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #5b8df6;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  height: 50px;
  border-radius: 10px;
}
.relevance {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #5d8bf6;
}

.foot {
  width: 100%;
  height: 4vh;
}
</style>
